import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Configuration for navigation links on the home page
 */
const NAVIGATION_LINK_SECTION_KEYS = [
  PUI.HOME_SECTION_KEYS.LINK_1,
  PUI.HOME_SECTION_KEYS.LINK_2,
  PUI.HOME_SECTION_KEYS.LINK_3,
  PUI.HOME_SECTION_KEYS.LINK_4,
  PUI.HOME_SECTION_KEYS.LINK_5,
] as const;

/**
 * Configuration for featured articles on the home page
 */
const ARTICLE_SECTION_KEYS = [
  PUI.HOME_SECTION_KEYS.ARTICLE_1,
  PUI.HOME_SECTION_KEYS.ARTICLE_2,
  PUI.HOME_SECTION_KEYS.ARTICLE_3,
] as const;

/**
 * Composable for home page configuration
 * Provides navigation links and articles configuration following SOC principles
 * Separates configuration logic from component presentation logic
 *
 * @returns {Object} Configuration object with navigationLinks and articles arrays
 *
 * @example
 * ```ts
 * const { navigationLinks, articles } = useHomePageConfig();
 * ```
 */
export const useHomePageConfig = () => {
  const navigationLinks = NAVIGATION_LINK_SECTION_KEYS.map((sectionKey) => ({
    sectionKey,
  }));

  const articles = ARTICLE_SECTION_KEYS.map((sectionKey) => ({
    sectionKey,
  }));

  return {
    navigationLinks,
    articles,
  };
};
